import type { FC } from "react";
import { SWReactIcons } from "@similarweb/icons";
import type { IServices } from "./useMarketingChannelsServices";
import styled from "styled-components";

const NoDataContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80%;
    width: 100%;
`;

const NoDataTitle = styled.span`
    font-size: 14px;
`;

const NoDataIcon = styled(SWReactIcons)`
    height: 90px;
    width: 194px;
    margin-bottom: 32px;
`;

interface IMarketingChannelsNoData {
    services: IServices;
}

export const MarketingChannelsNoData: FC<IMarketingChannelsNoData> = ({ services }) => {
    return (
        <NoDataContainer>
            <NoDataIcon iconName={"no-data-lab"} />
            <NoDataTitle>{services.translate("global.nodata.notavilable")}</NoDataTitle>
        </NoDataContainer>
    );
};
